import { joinPublicStorefrontUrl } from './client';

/** Fetch categories. Pass gender='male'|'female' to get only categories with products of that gender. */
export async function getCategories(gender) {
  try {
    const qs = gender === 'male' || gender === 'female' ? `?gender=${gender}` : '';
    const res = await fetch(joinPublicStorefrontUrl(`/api/categories${qs}`));
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (_) {
    return [];
  }
}

/** Min/max rent (₹) and distinct colors/sizes for shop filters; pass same ?category= / ?categoryId= / ?gender= as the product list. */
export async function getShopFilterOptions(queryString) {
  const raw = queryString != null ? String(queryString).replace(/^\?/, '') : '';
  try {
    const res = await fetch(
      joinPublicStorefrontUrl(`/api/products/filter-options${raw ? `?${raw}` : ''}`)
    );
    if (!res.ok) return null;
    const data = await res.json();
    return data && typeof data === 'object' ? data : null;
  } catch (_) {
    return null;
  }
}

export async function getPage(slug) {
  try {
    const res = await fetch(joinPublicStorefrontUrl(`/api/pages/${encodeURIComponent(slug)}`), {
      cache: 'no-store',
      headers: { Pragma: 'no-cache' },
    });
    if (!res.ok) return null;
    return res.json();
  } catch (_) {
    return null;
  }
}

/** Published blog listing (same shape as storefront). */
export async function getBlogPosts(params = {}) {
  const qs = new URLSearchParams();
  if (params.category != null && String(params.category).trim()) qs.set('category', String(params.category).trim());
  if (params.limit != null) qs.set('limit', String(params.limit));
  const raw = qs.toString();
  try {
    const res = await fetch(joinPublicStorefrontUrl(`/api/blog${raw ? `?${raw}` : ''}`));
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (_) {
    return [];
  }
}

/** Single published blog post by slug */
export async function getBlogPost(slug) {
  const s = String(slug || '').trim();
  if (!s) return null;
  try {
    const res = await fetch(joinPublicStorefrontUrl(`/api/blog/${encodeURIComponent(s)}`), {
      cache: 'no-store',
    });
    if (!res.ok) return null;
    return res.json();
  } catch (_) {
    return null;
  }
}

/** Homepage gallery strip (ordered images). */
export async function getHomeGallery() {
  try {
    const res = await fetch(joinPublicStorefrontUrl('/api/home-gallery'), { cache: 'no-store' });
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (_) {
    return [];
  }
}

/** Public hero slides for shop (context shop, key = category query or "") or CMS page (context page, key = slug). */
export async function getHeroSlides(context, key = '') {
  const params = new URLSearchParams();
  params.set('context', context === 'page' ? 'page' : 'shop');
  if (key != null && String(key).trim() !== '') params.set('key', String(key).trim());
  try {
    const res = await fetch(joinPublicStorefrontUrl(`/api/hero-slides?${params.toString()}`), {
      cache: 'no-store',
    });
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data.slides) ? data.slides : [];
  } catch (_) {
    return [];
  }
}

export async function getMenu(slug = 'header') {
  try {
    const res = await fetch(joinPublicStorefrontUrl(`/api/menu?slug=${encodeURIComponent(slug)}`));
    if (!res.ok) return [];
    return res.json();
  } catch (_) {
    return [];
  }
}
